import { exportHtml } from "@api/stores/purchaseInvoices/exportHtml/path";
import { exportPDF } from "@api/stores/purchaseInvoices/exportPDF/path";
import { items } from "@api/stores/purchaseInvoices/items/path";
import { payments } from "@api/stores/purchaseInvoices/payments/path";
import { returns } from "@api/stores/purchaseInvoices/returns/path";
import { stats } from "@api/stores/purchaseInvoices/stats/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/purchase-invoices/`;
const pathById = `${pathBase}:purchaseInvoiceId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const purchaseInvoices = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  delete: apiPathFunc(pathById),
  stats,
  returns,
  items,
  exportHtml,
  exportPDF,
  payments,
};
